export default __webpack_public_path__ + "static/media/Component7.7b3e7f3b.jpg";